/* eslint-disable no-console */
/* eslint-disable dot-notation */
import { handleErrors } from './ErrorActions';
import smartSolveApi from '../api/instances/smartsolve';

export const SET_ENTITY_HISTORY_DIALOG = 'SET_ENTITY_HISTORY_DIALOG';
export const CLEAR_ENTITY_HISTORY_DIALOG = 'CLEAR_ENTITY_HISTORY_DIALOG';
export const FETCH_ENTITY_HISTORY_SUCCESS = 'FETCH_ENTITY_HISTORY_SUCCESS';

export const setOpenEntityHistoryDialog = (isOpen) => ({
  type: SET_ENTITY_HISTORY_DIALOG,
  isOpen,
});

export const clearEntityHistoryDialog = () => ({
  type: CLEAR_ENTITY_HISTORY_DIALOG,
});

export const fetchEntityHistorySuccess = ({ rows }) => ({
  type: FETCH_ENTITY_HISTORY_SUCCESS,
  rows,
});

export const fetchEntityHistory = (entityId) => async (dispatch) => {
  try {
    const response = await smartSolveApi.post('/entity/history', { entityId });
    const { data } = response;
    if (data.hasError) {
      dispatch(handleErrors(data.errors));
    } else {
      dispatch(fetchEntityHistorySuccess({ rows: data.History['V_SSE_ENTITY_DEF'] ?? [] }));
    }
  } catch (error) {
    console.error(`Fetching Entity History failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};
